import { FC } from "react";
import { useTranslation } from "react-i18next";

import { IPassengerDeleteModalPayload } from "@ryde/shared";

import { ModalContentStyled } from "../controls";
import {
  ITEMS_TO_DISPLAY,
  RIDES_ONE_PASSENGER_NUMBER,
} from "./confirm.passenger-delete.constants";
import { ConfirmPassengerDeleteContent } from "./confirms.styled";

interface IPassengerDeleteBodyProps {
  confirmData: IPassengerDeleteModalPayload;
}

export const PassengerDeleteBody: FC<IPassengerDeleteBodyProps> = ({
  confirmData,
}) => {
  const { t } = useTranslation();

  const { passengers, ride } = confirmData;

  const isLastPassengerRemovedInEditMode =
    Boolean(ride?.id) &&
    ride?.metadata?.passengersCount === RIDES_ONE_PASSENGER_NUMBER &&
    passengers?.length === ride?.metadata?.passengersCount;

  const hiddenPassengersCount = (passengers?.length ?? 0) - ITEMS_TO_DISPLAY;

  return (
    <ModalContentStyled>
      <ConfirmPassengerDeleteContent>
        <ul>
          {passengers?.slice(0, ITEMS_TO_DISPLAY)?.map(passenger => (
            <li key={passenger.id}>
              {passenger.lastName} {passenger.firstName}
            </li>
          ))}
        </ul>
        {isLastPassengerRemovedInEditMode && (
          <div className="pass_more_info">
            {t("ride.RIDE_WILL_BE_CANCELED", { rideId: ride?.id })}
          </div>
        )}
        {hiddenPassengersCount > 0 && (
          <div className="pass_more_info">
            {t(`general.AND`)}
            <span className="count_label">{hiddenPassengersCount}</span>
            {t(`general.MORE_PASSENGERS`)}
          </div>
        )}
      </ConfirmPassengerDeleteContent>
    </ModalContentStyled>
  );
};
